export default class IntegrationMyobAPIService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  // Contacts
  getMyobContactList()                { return this.httpClient.get(`/integrations/myob/myobContacts`) }
  getContactFromMyob(myobContactID)   { return this.httpClient.get(`/integrations/myob/myobContacts/${myobContactID}`) }
  relinkContact(contactId, data)      { return this.httpClient.post(`/integrations/myob/relink/contacts/${contactId}`, data) }

  // Config
  getConfig()                         { return this.httpClient.get(`/integrations/myob/config`) }
  getTaxRateConfigList()              { return this.httpClient.get(`/integrations/myob/taxrateconfigs`) }
  getAccountConfigList()              { return this.httpClient.get(`/integrations/myob/accountconfigs`) }
  updateConfig(data)                  { return this.httpClient.put(`/integrations/myob/config`, data) }

  getSyncErrorList()                  { return this.httpClient.get(`/integrations/myob/syncerrors`) }
  clearSyncErrorMessage(data)         { return this.httpClient.post(`/integrations/myob/syncerrors/clear`, data) }

  // Myob Data Access
  getMyobCompanyFileList()            { return this.httpClient.get(`/integrations/myob/myobcompanyfiles`) }
  getMyobAccountList()                { return this.httpClient.get(`/integrations/myob/myobaccounts`) }
  getMyobTaxCodeList()                { return this.httpClient.get(`/integrations/myob/myobtaxcodes`) }
  
}
